module.exports = __webpack_public_path__ + "static/media/5@3x.e9c14764.png";